import {
  GET_WOO_COMMERCE_SKUS_ERROR,
  GET_WOO_COMMERCE_SKUS_SUCCESS,
} from "../constants";

export const initialState = {
  skuDataForDropdown: undefined,
};
export const WooCommerceReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_WOO_COMMERCE_SKUS_SUCCESS: {
      return {
        ...state,
        skuDataForDropdown: action.payload,
      };
    }
    case GET_WOO_COMMERCE_SKUS_ERROR: {
      return {
        ...state,
        skuDataForDropdown: undefined,
      };
    }
    default:
      return state;
  }
};
